
import withRoot from "../withRoot";
import { useManufacturer } from "../contexts/WithManufacturer";
import React from "react";
import {
  PartnerRelationshipPage as PartnerRelationshipPageContent
} from "randmarcomps";
import { useParams } from "react-router-dom";
import { useUser } from "../hooks/useUser";

const PartnerRelationshipPage: React.FC = () => {
  const { applicationId } = useManufacturer();
  const { partnerId } = useParams<{ partnerId: string }>();
  const { user, isSuperAdmin } = useUser();
  const userEmail = user?.profile?.email ?? "";

  return (
    <main className="max-w-6xl mx-auto">
      <h1 className="text-2xl font-bold">
        Partner's Relationship
      </h1>
      <div className="mt-6">
        <PartnerRelationshipPageContent
            applicationId={applicationId}
            partnerId={partnerId ?? ""}
            userEmail={userEmail}
            isSuperAdmin={isSuperAdmin}
            shopifyHostName={undefined}
        />
      </div>
    </main>
  );
};

export default withRoot(PartnerRelationshipPage);
